export default class AuthorizationShop {
    userId: string;
    shopId: number;
    shopName: string;
    country: string;
    customShopName: string;
    authTime: Date;
    expireTime: Date;
    shopeeStatus: number;
}